module.exports = __webpack_public_path__ + "static/img/win8.aae7f0c7.png";